import * as Yup from 'yup';
import i18n from 'i18next';

export const schema = Yup.object().shape({
  type: Yup.string().required(i18n.t('common.fieldRequiredMessage')),
  year: Yup.number()
    .typeError('Must be a number')
    .required(i18n.t('common.fieldRequiredMessage'))
    .test(
      'len',
      `Must be a year between 1970 & ${new Date().getFullYear()} in yyyy format `,
      (val) => val && val.toString().length === 4 && val > 1969 && val < new Date().getFullYear() + 1
    ),
  make: Yup.string().required(i18n.t('common.fieldRequiredMessage')),
  model: Yup.string().required(i18n.t('common.fieldRequiredMessage')),
  unitId: Yup.string().required(i18n.t('common.fieldRequiredMessage')),
});
